/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type ApprovableStatus = "APPROVED" | "CANCELLED" | "PENDING" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type MFADeactivationRequestListForm_viewer$ref: FragmentReference;
declare export opaque type MFADeactivationRequestListForm_viewer$fragmentType: MFADeactivationRequestListForm_viewer$ref;
export type MFADeactivationRequestListForm_viewer = {|
  +id: string,
  +status: ApprovableStatus,
  +forUser: {|
    +id: string,
    +email: string,
  |},
  +approvals: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +approvedBy: {|
          +id: string,
          +username: string,
        |},
        +approvedAt: any,
      |}
    |}>
  |},
  +hasCompleteApprovals: ?boolean,
  +$refType: MFADeactivationRequestListForm_viewer$ref,
|};
export type MFADeactivationRequestListForm_viewer$data = MFADeactivationRequestListForm_viewer;
export type MFADeactivationRequestListForm_viewer$key = {
  +$data?: MFADeactivationRequestListForm_viewer$data,
  +$fragmentRefs: MFADeactivationRequestListForm_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "MFADeactivationRequestListForm_viewer",
  "type": "MFADeactivationRequestNode",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "forUser",
      "storageKey": null,
      "args": null,
      "concreteType": "UserNode",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "approvals",
      "storageKey": null,
      "args": null,
      "concreteType": "ApprovalNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "ApprovalNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "ApprovalNode",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "approvedBy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserNode",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "username",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "approvedAt",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "hasCompleteApprovals",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e1fd76a3a4598de6064741274ca4c7df';
module.exports = node;
